<div
  pTooltip="{{ tooltipText }}"
  [escape]="false"
  [showDelay]="showDelay"
  [hideDelay]="hideDelay"
  [tooltipPosition]="tooltipPosition"
  [tooltipStyleClass]="tooltipStyleClass"
  class="tooltip-wrapper"
>
  <ng-content></ng-content>
</div>